import React, { Component } from "react"
import ThemeContext from "shared/context"

import "./header.scss"
import iconFacebook from "shared/assets/icons/facebook.svg"
import iconInstagram from "shared/assets/icons/instagram.svg"

class Header extends Component {
  handleClickEvent(event) {
    event.preventDefault()
    this.props.toggleContentHandler()
  }

  render() {
    return (
      <div className={`c-Header${this.context.theme === 'light' ? ' c-Header--light' : ''}`}>
        <div className="c-Header-social">
          <a href="https://www.instagram.com/citizen_long/" className="c-Header-socialLink"><img src={iconInstagram} className="c-Header-socialIcon" /></a>
          <a href="https://www.facebook.com/citizenlong/" className="c-Header-socialLink"><img src={iconFacebook} className="c-Header-socialIcon" /></a>
        </div>
        <a href="#" className={`c-Header-button`} onClick={ (event) => { this.handleClickEvent(event) }}>Men&uuml;</a>
      </div>
    )
  }
}

Header.contextType = ThemeContext
export default Header